import { makeAutoObservable } from "mobx";
import i18n from "i18n";
import {
  getEpisodeOfCare,
  createEpisodeOfCare,
  editEpisodeOfCare,
  deleteEpisodeOfCare,
  //   checkCode,
} from "../Services/EpisodeOfCareService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

export default class EpisodeOfCareStore {
  episodeOfCareList = [];
  selectedEpisodeOfCare = null;
  initialValue = {
    id: "",
    appointmentDto: null,
    episodeOfCareDate: null,
    startDate: null,
    endDate: null,
    episodeOfCareType: null,
    indexNumber: null,
    isLatestEpisodeOfCare: false,
    treatmentPeriodDto: null,
    episodeOfCareCareType: null,
    episodeOfCareStage: null,
    orgEpisodeOfCare: null,
    provider: null,
    patient: null,
    medicationRequests: [],
    listSymptoms: [],
    listDiagnosis: [],
    listLabTests: [],
    listImagingStudys: [],
  };
  selectedEpisodeOfCareList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  text = "";
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleEditEpisodeOfCare = (id) => {
    this.getEpisodeOfCare(id).then(() => {
      this.shouldOpenEditorDialog = true;
    });
  };

  handleClose = () => {
    this.shouldOpenEditorDialog = false;
    this.shouldOpenConfirmationDialog = false;
    this.shouldOpenConfirmationDeleteListDialog = false;
    // this.updatePageData();
  };

  handleDelete = (id) => {
    this.getEpisodeOfCare(id).then(() => {
      this.shouldOpenConfirmationDialog = true;
    });
  };

  handleDeleteList = () => {
    this.shouldOpenConfirmationDeleteListDialog = true;
  };

  handleConfirmDelete = () => {
    this.deleteEpisodeOfCare(this.selectedEpisodeOfCare.id);
  };

  handleConfirmDeleteList = async () => {
    let listAlert = [];
    for (var i = 0; i < this.selectedEpisodeOfCareList.length; i++) {
      try {
        await deleteEpisodeOfCare(this.selectedEpisodeOfCareList[i].id);
      } catch (error) {
        listAlert.push(this.selectedEpisodeOfCareList[i].name);
        console.log(error);
        console.log(listAlert.toString());
        toast.warning(i18n.t("toast.error"));
      }
    }
    this.handleClose();
    toast.success(i18n.t("toast.delete_success"));
  };

  handleSelectEpisodeOfCare = (episodeOfCare) => {
    this.selectedEpisodeOfCare = episodeOfCare;
  };

  handleSelectListEpisodeOfCare = (episodeOfCares) => {
    this.selectedEpisodeOfCareList = episodeOfCares;
  };

  getEpisodeOfCare = async (id) => {
    if (id != null) {
      try {
        let data = await getEpisodeOfCare(id);

        this.handleSelectEpisodeOfCare(data.data);
        // console.log(this.selectedEpisodeOfCare)
        return this.selectedEpisodeOfCare;
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      this.handleSelectEpisodeOfCare(this.initialValue);
    }
  };

  createEpisodeOfCare = async (episodeOfCare) => {
    try {
      await createEpisodeOfCare(episodeOfCare);
      toast.success(i18n.t("toast.add_success"));
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.add_fail"));
    }
  };

  editEpisodeOfCare = async (episodeOfCare) => {
    try {
      await editEpisodeOfCare(episodeOfCare);
      toast.success(i18n.t("toast.update_success"));
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.update_fail"));
    }
  };

  deleteEpisodeOfCare = async (id) => {
    try {
      await deleteEpisodeOfCare(id);
      toast.success(i18n.t("toast.delete_success"));
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.delete_fail"));
    }
  };
}
